<script lang="ts" setup>
import { LoaderBlockDomain } from '@UI/Loaders/LoaderBlockDomain'

defineOptions({
  name: 'SkeletonLearningProgress',
})
</script>

<template>
  <div class="skeleton-learning-progress">
    <LoaderBlockDomain />
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Skeletons/LearningProgress/SkeletonLearningProgress.scss" />
